
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/post/[id]",
      function () {
        return require("private-next-pages/community/post/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/post/[id]"])
      });
    }
  